import { useQuery } from "@tanstack/react-query";
import { instrumentSearchService, type InstrumentSearchParams } from "@/services/instrumentSearchService";

export function useInstrumentSearch(params: InstrumentSearchParams, enabled: boolean) {
  return useQuery({
    queryKey: ["market-data", "instruments", params],
    queryFn: () => instrumentSearchService.search(params),
    enabled,
  });
}

/** Backend v2.1 (Sprint 4.4) `GET /market-data/instrument` - single-instrument metadata by token. */
export function useInstrumentMetadata(instrumentToken: string | null) {
  return useQuery({
    queryKey: ["market-data", "instrument", instrumentToken],
    queryFn: () => instrumentSearchService.getMetadata(instrumentToken as string),
    enabled: Boolean(instrumentToken),
  });
}
